/* Material */
import Typo from '@mui/material/Typography'

/* Functions */
import formatEuro from 'src/functions/formatEuro'

/* Config */
import config from 'src/config'

const { mindermengenzuschlag } = config

interface Props {
  summe: number
}

const MindermengenzuschlagHinweis = ({summe}:Props) => {

  const RestBetrag = mindermengenzuschlag.entfaelltAb - summe
  if (RestBetrag <= 0) return null

  return <div>
    <Typo variant='subtitle2'>
      Noch {formatEuro(RestBetrag)} bis der Mindermengenzuschlag entfällt. 
    </Typo>
  </div>
}


export default MindermengenzuschlagHinweis
